import React, { useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import {
  Row,
  Col,
  Collapse,
  Table,
  Input,
  Button,
  DatePicker,
  Empty,
  TimePicker,
} from "antd";
import { DoubleRightOutlined, SearchOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import "./FileTraceTableSection";
import Highlighter from "react-highlight-words";
import { Resizable } from "react-resizable";
import ReactDragListView from "react-drag-listview";
import {
  IconSwitcher,
  CustDropdown,
  PopupContainer,
  FileDownloadFromCell,
} from "./FileTraceTableUtils";
import CommonConfig from "../../../commonConfig.json";
import "./FileTraceTableSection.css";

import moment from "moment";

const { Panel } = Collapse;
const { TextArea } = Input;

let accessType = {
  END_USER: "END_USER",
  CORPORATE: "CORPORATE",
  ONBOARDING_TEAM: "ONBOARDING_TEAM",
};
const ENVS = CommonConfig.envs;
const REACT_APP_HMG = process.env["REACT_APP_HMG"]

/** Start of Resizable Component of react-resizable */
const ResizeableTitle = (props) => {
  const { onResize, width, onClick, ...restProps } = props;
  const [allowClick, setAllowClick] = useState(true);

  if (!width) {
    return <th {...restProps} />;
  }
  return (
    <Resizable
      width={width}
      height={0}
      onResize={onResize}
      onMouseDown={(e) => {
        setAllowClick(true);
      }}
      onResizeStart={(e) => {
        setAllowClick(false);
      }}
      onClick={(e) => allowClick && onClick(e)}
    >
      <th {...restProps} />
    </Resizable>
  );
};
/** End of Resizable Component of react-resizable */

function TableIndexComponent(props) {
  // alert(props.index)
  let indexValues = props.record[props.index];
  if (indexValues != undefined) {
    // indexValues.sort((a, b) => {
    //   return (a.docId > b.docId)?1:-1;
    // });

    let valueSet = indexValues.map((index) => {
      return <div key={props.index + "_" + index.docId}>{index.value}</div>;
    });

    return <>{valueSet}</>;
  } else {
    return "";
  }
}

function TableIndexDateComponent(props) {
  let indexValues = props.record[props.index];
  if (indexValues != undefined) {
    // indexValues.sort((a, b) => {
    //   return (a.docId > b.docId)?1:-1;
    // });

    let valueSet = indexValues.map((index) => {
      let format = props.format.split("'").join("");
      let momentObj = moment(index.value, "MM-DD-YYYY");
      if (!momentObj._isValid) {
        momentObj = moment.utc(index.value);
      }

      let timeExists = format.includes("HH") || format.includes("hh");
      return (
        <div key={"dte_tme_" + index.docId}>
          <DatePicker
            key={"dte_" + index.docId}
            defaultValue={momentObj}
            style={{ width: "50%" }}
            placeholder="MM-DD-YYYY"
            format={"MM-DD-YYYY"}
            disabled
            showToday={false}
          />
          {timeExists ? (
            <TimePicker
              key={"tme_" + index.docId}
              style={{ width: "50%" }}
              defaultValue={momentObj}
              format={"HH:mm:ss"}
              disabled
            />
          ) : (
            ""
          )}
        </div>
      );
    });

    return <>{valueSet}</>;
  } else {
    return "";
  }
}

class FileTraceTableSection extends React.Component {
  constructor(props) {
    super(props);

    let columnTemplate = {
      FILENAME: {
        key: "FILENAME",
        val: {
          title: "File Name",
          dataIndex: "fileName",
          key: "fileName",
          fixed: "left",
          width: 200,
          align: "center",
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => {
            return a.fileName.localeCompare(b.fileName);
          },
          ...this.getColumnSearchProps("fileName"),
        },
      },
      CONNECTOR: {
        key: "CONNECTOR",
        val: {
          title: "Submission Method",
          dataIndex: "connector",
          key: "connector",
          width: 200,
          align: "center",
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => {
            return a.fileName.localeCompare(b.fileName);
          },
          ...this.getColumnSearchProps("connector"),
        },
      },
      FILE_ACCEPTED: {
        key: "FILE_ACCEPTED",
        val: {
          title: "Received",
          dataIndex: "accepted",
          key: "accepted",
          width: 150,
          align: "center",
          render: (accepted) => <IconSwitcher value={accepted} />,
          filters: [
            {
              text: <IconSwitcher value={"n/a"} />,
              value: "n/a",
            },
            {
              text: <IconSwitcher value={"yes"} />,
              value: "yes",
            },
            {
              text: <IconSwitcher value={"no"} />,
              value: "no",
            },
            {
              text: <IconSwitcher value={"sync"} />,
              value: "sync",
            },
          ],
          onFilter: (value, record) =>
            record.accepted.toLowerCase().indexOf(value) === 0,
        },
      },
      SOLUTION: {
        key: "SOLUTION",
        val: {
          title: "Solution",
          dataIndex: "solution",
          key: "solution",
          width: 150,
          align: "center",
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => {
            return a.solution.localeCompare(b.solution);
          },
          ...this.getColumnSearchProps("solution"),
        },
      },
      IDENTIFICATION: {
        key: "IDENTIFICATION",
        val: {
          title: "Identification",
          dataIndex: "identification",
          key: "identification",
          width: 150,
          align: "center",
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => {
            return a.identification.localeCompare(b.identification);
          },
          ...this.getColumnSearchProps("identification"),
        },
      },
      MYDOCS_RAW_FILE_STATUS: {
        key: "MYDOCS_RAW_FILE_STATUS",
        val: {
          title: "Raw file in myDocs",
          dataIndex: "mydocsRaw",
          key: "mydocsRaw",
          width: "150px",
          align: "center",
          render: (mydocsRaw, record, index) =>
            record.mydocs.value == "N/A" ? (
              <IconSwitcher value={"N/A"} />
            ) : (
              <FileDownloadFromCell
                fileDownloadPermit={
                  this.props.permitExtraDetails.FileDownloadPermit
                }
                value={<IconSwitcher value={mydocsRaw.value} />}
                data={mydocsRaw}
              />
            ),
          filters: [
            {
              text: <IconSwitcher value={"n/a"} />,
              value: "n/a",
            },
            {
              text: <IconSwitcher value={"yes"} />,
              value: "yes",
            },
            {
              text: <IconSwitcher value={"no"} />,
              value: "no",
            },
            {
              text: <IconSwitcher value={"sync"} />,
              value: "sync",
            },
          ],
          onFilter: (value, record) =>
            record.mydocsRaw.value.toLowerCase().indexOf(value) === 0,
        },
      },
      FILE_TYPE: {
        key: "FILE_TYPE",
        val: {
          title: "File Type",
          dataIndex: "fileType",
          key: "fileType",
          width: 150,
          align: "center",
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => {
            return a.fileType.localeCompare(b.fileType);
          },
          ...this.getColumnSearchProps("fileType"),
        },
      },
      INDEXING: {
        key: "INDEXING",
        val: {
          title: "Indexing",
          dataIndex: "indexing",
          key: "indexing",
          width: 150,
          align: "center",
          className: "popupContainerCell",
          render: (indexing, record, index) =>
            record.mydocs.value == "N/A" ? ( //need to change logic
              "N/A"
            ) : indexing.display ? (
              <PopupContainer
                value={<IconSwitcher value={indexing.value} />}
                popupData={indexing}
                openModal={this.props.openModal}
                permitExtraDetails={this.props.permitExtraDetails}
              />
            ) : (
              <IconSwitcher value={indexing.value} />
            ),
          filters: [
            {
              text: <IconSwitcher value={"n/a"} />,
              value: "n/a",
            },
            {
              text: <IconSwitcher value={"yes"} />,
              value: "yes",
            },
            {
              text: <IconSwitcher value={"no"} />,
              value: "no",
            },
            {
              text: <IconSwitcher value={"sync"} />,
              value: "sync",
            },
          ],
          onFilter: (value, record) =>
            record.indexing.value.toLowerCase().indexOf(value) === 0,
        }
      },
      SMART_SCANING: {
        key: "SMART_SCANING",
        val: {
          title: "Smart Scanning",
          dataIndex: "smartScanning",
          key: "smartScanning",
          width: 150,
          align: "center",
          className: "popupContainerCell",
          render: (smartScanning, record, index) =>
            record.mydocs.value == "N/A" ? (
              "N/A"
            ) : smartScanning.display ? (
              <PopupContainer
                value={<IconSwitcher value={smartScanning.value} />}
                popupData={smartScanning}
                openModal={this.props.openModal}
                permitExtraDetails={this.props.permitExtraDetails}
              />
            ) : (
              <IconSwitcher value={smartScanning.value} />
            ),
          filters: [
            {
              text: <IconSwitcher value={"n/a"} />,
              value: "n/a",
            },
            {
              text: <IconSwitcher value={"yes"} />,
              value: "yes",
            },
            {
              text: <IconSwitcher value={"no"} />,
              value: "no",
            },
            {
              text: <IconSwitcher value={"sync"} />,
              value: "sync",
            },
          ],
          onFilter: (value, record) =>
            record.smartScanning.value.toLowerCase().indexOf(value) === 0,
        },
      },
      CONVERSION: {
        key: "CONVERSION",
        val: {
          title: "Conversion",
          dataIndex: "conversion",
          key: "conversion",
          width: "150px",
          align: "center",
          render: (conversion, record, index) =>
            record.mydocs.value == "N/A" ? (
              "N/A"
            ) : conversion.display ? (
              <PopupContainer
                value={<IconSwitcher value={conversion.value} />}
                popupData={conversion}
                openModal={this.props.openModal}
                permitExtraDetails={this.props.permitExtraDetails}
              />
            ) : (
              <IconSwitcher value={conversion.value} />
            ),
          filters: [
            {
              text: <IconSwitcher value={"n/a"} />,
              value: "n/a",
            },
            {
              text: <IconSwitcher value={"yes"} />,
              value: "yes",
            },
            {
              text: <IconSwitcher value={"no"} />,
              value: "no",
            },
            {
              text: <IconSwitcher value={"sync"} />,
              value: "sync",
            },
          ],
          onFilter: (value, record) =>
            record.conversion.value.toLowerCase().indexOf(value) === 0,
        },
      },
      REDACTION: {
        key: "REDACTION",
        val: {
          title: "Redaction",
          dataIndex: "redaction",
          key: "redaction",
          width: 150,
          align: "center",
          className: "popupContainerCell",
          render: (redaction, record, index) =>
            record.mydocs.value == "N/A" ? ( //need to change logic
              "N/A"
            ) : redaction.display ? (
              <PopupContainer
                value={<IconSwitcher value={redaction.value} />}
                popupData={redaction}
                openModal={this.props.openModal}
                permitExtraDetails={this.props.permitExtraDetails}
              />
            ) : (
              <IconSwitcher value={redaction.value} />
            ),
          filters: [
            {
              text: <IconSwitcher value={"n/a"} />,
              value: "n/a",
            },
            {
              text: <IconSwitcher value={"yes"} />,
              value: "yes",
            },
            {
              text: <IconSwitcher value={"no"} />,
              value: "no",
            },
            {
              text: <IconSwitcher value={"sync"} />,
              value: "sync",
            },
          ],
          onFilter: (value, record) =>
            record.redaction.value.toLowerCase().indexOf(value) === 0,
        }
      },
      MYDOCS_AVAILABLE: {
        key: "MYDOCS_AVAILABLE",
        val: {
          title: "Available in myDocs",
          dataIndex: "mydocs",
          key: "mydocs",
          width: "150px",
          align: "center",
          render: (mydocs) => <IconSwitcher value={mydocs.value} />,
          filters: [
            {
              text: <IconSwitcher value={"n/a"} />,
              value: "n/a",
            },
            {
              text: <IconSwitcher value={"yes"} />,
              value: "yes",
            },
            {
              text: <IconSwitcher value={"no"} />,
              value: "no",
            },
            {
              text: <IconSwitcher value={"sync"} />,
              value: "sync",
            },
          ],
          onFilter: (value, record) =>
            record.mydocs.value.toLowerCase().indexOf(value) === 0,
        },
      },
      HMG: {
        key: "HMG",
        val: {
          title: "Hotel Management Group",
          dataIndex: "hotelMgtGroup",
          key: "hotelMgtGroup",
          width: 300,
          align: "center",
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => {
            return a.hotelMgtGroup.localeCompare(b.hotelMgtGroup);
          },
          ...this.getColumnSearchProps("hotelMgtGroup"),
        },
      },
      // HOTEL_NAME: {
      //   key: 'HOTEL_NAME',
      //   val: {
      //     title: 'Hotel Name',
      //     dataIndex: 'hotelName',
      //     key: 'hotelName',
      //     width: 300,
      //     align: 'center',
      //     sortDirections: ['ascend','descend'],
      //     sorter: (a, b) => {return a.hotelName.localeCompare(b.hotelName)},
      //     ...this.getColumnSearchProps('hotelName'),
      //   }
      // },
      // HOTEL_CODE: {
      //   key: 'HOTEL_CODE',
      //   val: {
      //     title: 'Hotel Code',
      //     dataIndex: 'marshaCode',
      //     key: 'marshaCode',
      //     width: 200,
      //     align: 'center',
      //     sortDirections: ['ascend','descend'],
      //     sorter: (a, b) => {return a.marshaCode.localeCompare(b.marshaCode)},
      //     ...this.getColumnSearchProps('marshaCode'),
      //   }
      // },
      MYDOCS_REPORT_NAME: {
        key: "MYDOCS_REPORT_NAME",
        valuesType: "Report",
        val: {
          title: "myDocs Report Name",
          dataIndex: "reports",
          key: "reports",
          width: 300,
          align: "center",
          // sorter: (a, b) => a.reports.length - b.reports.length,
          // sortDirections: ['descend', 'ascend'],
          render: (reports, record, index) => (
            // console.log('index at report',record,index)
            <CustDropdown
              index={index}
              editedDropdown={this.props.editedDropdown}
              dropdownChange={this.dropdownChange}
              cellInfo={record}
              isEditable={this.props.isEditable}
              mappedReports={this.props.mappedReports}
              solution={this.props.solution}
            />
          ),
          // ...this.getColumnSearchProps('reports'),
        },
      },
      BUSINESS_DATE: {
        key: "BUSINESS_DATE",
        valuesType: "Date",
        val: {
          title: "Business Date",
          dataIndex: "businessDate",
          key: "businessDate",
          width: 200,
          align: "center",
          render: (bd, record) => {
            return this.genBusinessDates(record);
          },
        },
      },
      SCHEDULE_TYPE: {
        key: "SCHEDULE_TYPE",
        valuesType: "Submission Schedule",
        val: {
          title: "Schedule Type",
          dataIndex: "ScheduleType",
          key: "ScheduleType",
          width: 200,
          align: "center",
          render: (bd, record) => {
            return this.genScheduleTytpes(record);
          },
        },
      },
      UPLOADED_BY: {
        key: "UPLOADED_BY",
        val: {
          title: "Uploaded By",
          dataIndex: "uploadedBy",
          key: "uploadedBy",
          width: 200,
          align: "center",
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => {
            return a.uploadedBy.localeCompare(b.uploadedBy);
          },
          ...this.getColumnSearchProps("uploadedBy"),
        },
      },
      NOTES: {
        key: "NOTES",
        val: {
          title: "Notes",
          dataIndex: "notes",
          key: "notes",
          width: 300,
          align: "center",
          render: (notes, record, index) => {
            // alert(record+' '+notes+' '+index)
            return this.renderEditable(record, "notes", index);
          },
          // ...this.getColumnSearchProps('notes'),
        },
      },
      CHAINID: {
        key: "CHAINID",
        val: {
          title: "Chain Id",
          dataIndex: "chainId",
          key: "chainId",
          width: 200,
          align: "center",
          ...this.getColumnSearchProps("chainId"),
        },
      },
      EVENT_TIME: {
        key: "EVENTTIME",
        val: {
          title: "Session Details",
          dataIndex: "eventTime",
          key: "eventTime",
          width: 200,
          align: "center",
          ...this.getColumnSearchProps("eventTime"),
        },
      },
    };

    let tableIndexes = this.props.tableIndexes;

    let columnset = [];
    //starting cols
    if (props.accessType == accessType.END_USER) {
      columnset = [
        columnTemplate.FILENAME.val,
        columnTemplate.CONNECTOR.val,
        columnTemplate.SOLUTION.val,
        columnTemplate.FILE_ACCEPTED.val,
        columnTemplate.SMART_SCANING.val,
        columnTemplate.MYDOCS_AVAILABLE.val,
      ];
    } else if (props.accessType == accessType.ONBOARDING_TEAM) {
      if (REACT_APP_HMG === ENVS.MARRIOTT) { //show serverless file processing (lmd) only in marriott environment
        columnset = [
          columnTemplate.FILENAME.val,
          columnTemplate.CONNECTOR.val,
          columnTemplate.FILE_ACCEPTED.val,
          columnTemplate.SOLUTION.val,
          columnTemplate.IDENTIFICATION.val,
          columnTemplate.MYDOCS_RAW_FILE_STATUS.val,
          columnTemplate.FILE_TYPE.val,
          columnTemplate.INDEXING.val,
          columnTemplate.SMART_SCANING.val,
          columnTemplate.CONVERSION.val,
          columnTemplate.REDACTION.val,
          columnTemplate.MYDOCS_AVAILABLE.val,
          columnTemplate.HMG.val,
        ];
      } else {
        columnset = [
          columnTemplate.FILENAME.val,
          columnTemplate.CONNECTOR.val,
          columnTemplate.FILE_ACCEPTED.val,
          columnTemplate.SOLUTION.val,
          columnTemplate.IDENTIFICATION.val,
          columnTemplate.MYDOCS_RAW_FILE_STATUS.val,
          columnTemplate.FILE_TYPE.val,
          columnTemplate.SMART_SCANING.val,
          columnTemplate.CONVERSION.val,
          columnTemplate.MYDOCS_AVAILABLE.val,
          columnTemplate.HMG.val,
        ];
      }
    } else if (props.accessType == accessType.CORPORATE) {
      columnset = [
        columnTemplate.FILENAME.val,
        columnTemplate.CONNECTOR.val,
        columnTemplate.FILE_ACCEPTED.val,
        columnTemplate.SOLUTION.val,
        columnTemplate.SMART_SCANING.val,
        columnTemplate.MYDOCS_AVAILABLE.val,
      ];
    }

    let indexSortOrder = props.indexSortOrder;
    tableIndexes.forEach((tableIndex) => {
      let contains = false;
      for (const sortOrder of indexSortOrder) {
        // alert(JSON.stringify(tableIndex)+"  -- "+JSON.stringify(sortOrder))
        if (tableIndex["_id"] === sortOrder["indexId"]) {
          tableIndex.order = sortOrder.order;
          contains = true;
        }
      }

      if (!contains) {
        tableIndex.order = 9999;
      }
    });

    tableIndexes.sort(function (a, b) {
      return a.order > b.order ? 1 : -1;
    });

    tableIndexes.forEach((tableIndex) => {
      let component = {
        title: tableIndex.name,
        dataIndex: tableIndex.name,
        key: tableIndex.name,
        width: tableIndex.type == "Date" ? 300 : 200,
        align: "center",
        render: (reports, record, index) =>
          // console.log('index at report',record,index)
          tableIndex.type == "Date" ? (
            <TableIndexDateComponent
              record={record}
              index={tableIndex.name}
              format={tableIndex.format}
            />
          ) : (
            <TableIndexComponent record={record} index={tableIndex.name} />
          ),
      };

      //check custom index
      let templateKeys = Object.keys(columnTemplate);
      for (const templateKey of templateKeys) {
        let template = columnTemplate[templateKey];
        if (
          template.valuesType != undefined &&
          tableIndex.valuesType === template.valuesType
        ) {
          //custom exists
          component = template.val;
          component.title = tableIndex.name;
          break;
        }
      }

      //push to col list
      columnset.push(component);
    });

    // alert(JSON.stringify(tableIndexes))
    //Ending cols
    if (props.accessType == accessType.END_USER) {
      columnset.push(columnTemplate.UPLOADED_BY.val);
    } else if (props.accessType == accessType.ONBOARDING_TEAM) {
      columnset.push(columnTemplate.UPLOADED_BY.val);
      columnset.push(columnTemplate.NOTES.val);
      columnset.push(columnTemplate.CHAINID.val);
      columnset.push(columnTemplate.EVENT_TIME.val);
    } else if (props.accessType == accessType.CORPORATE) {
      columnset.push(columnTemplate.UPLOADED_BY.val);
      columnset.push(columnTemplate.EVENT_TIME.val);
    }

    console.log("COL SET :", columnset);

    this.state = {
      tabId: props.tabId,
      updateSessionData: props.updateSessionData,
      updateDropdownData: props.updateDropdownData,
      // sessionDate: props.sessionDate,
      sessionTime: props.sessionTime,
      //sessionCollapse: '0',
      sessionCard: props.sessionTime,
      searchText: "",
      searchedColumn: "",
      openModal: props.openModal,
      columns: columnset,
      innerHeight: window.innerHeight,
      filterUsed: null,
    };

    //bind state to methods
    this.renderEditable = this.renderEditable.bind(this);
    this.dropdownChange = this.dropdownChange.bind(this);
    this.showTot = this.showTot.bind(this);
    // this.sortCallback = this.sortCallback.bind(this);
    //this.toggleSessions = this.toggleSessions.bind(this);

    /** Start Dragable Columns with AntD */
    const that = this;
    this.dragProps = {
      onDragEnd(fromIndex, toIndex) {
        const columns = that.state.columns;
        const item = columns.splice(fromIndex, 1)[0];
        columns.splice(toIndex, 0, item);
        that.setState({
          columns,
        });
      },
      nodeSelector: "th",
    };
    /** End Dragable Columns with AntD */
  }

  /** Start AntD Table Resize */

  /** Resize Column Function */
  handleResize =
    (index) =>
    (e, { size }) => {
      this.setState(({ columns }) => {
        const nextColumns = [...columns];
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        };
        return { columns: nextColumns };
      });
    };

  components = {
    header: {
      cell: ResizeableTitle,
    },
  };
  /** End AntD Table Resize */

  //allow to edit text cells
  renderEditable(cellInfo, col, index) {
    // console.log('notes cell infor',cellInfo,'col',col,'index',index,'celinfo.col',cellInfo[col]);
    if (this.props.isEditable) {
      return (
        <div>
          <TextArea
            className={
              this.props.isEditable
                ? "customInputActive"
                : "customInputDisabled"
            }
            disabled={!this.props.isEditable}
            defaultValue={cellInfo[col]}
            allowClear
            // value={cellInfo[col]}
            onChange={(e) => {
              const data = cloneDeep(this.props.tableData);
              //data[index][col] = e.target.value;
              for (let y = 0; y < data.length; y++) {
                let record = data[y];
                if (record["chainId"] === cellInfo["chainId"]) {
                  record[col] = e.target.value;
                  break;
                }
              }
              // console.log(data[index].col,'this.props.editedRows')
              //let newEditedRows = this.pushSet(index, this.props.editedRows, true);
              let newEditedRows = this.pushSet(
                cellInfo["chainId"],
                this.props.editedRows,
                false
              );
              this.state.updateSessionData(
                this.state.sessionTime,
                data,
                newEditedRows
              );
            }}
            placeholder={"Add " + col}
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </div>
      );
    } else {
      return <div>{cellInfo[col]}</div>;
    }
  }

  //execute onChange of reports
  dropdownChange(id, value, cellindex) {
    //change state container of dropdown value for docid
    let newDDObject = {};
    newDDObject["ddId"] = id;
    newDDObject["ddVal"] = value;

    //add unique(pushSet) cell index to edited rows
    const newEditedRows = this.pushSet(cellindex, this.props.editedRows, true);
    this.state.updateDropdownData(
      this.state.sessionTime,
      newDDObject,
      newEditedRows
    );
  }

  //mimic java Collections -> Set data structure on arrays
  pushSet(val, arr, parse) {
    for (let x = 0; x < arr.length; x++) {
      if (arr[x] == val) {
        return arr;
      }
    }
    val = parse ? parseInt(val) : val;
    arr.push(val);
    return arr;
  }

  //format business dates
  genBusinessDates(cellInfo) {
    let dates = cellInfo.businessDate;
    if (cellInfo.mydocs.value != "N/A") {
      const dateFormat = "MM-DD-YYYY";
      let bdatepickers = [];

      dates.map((date) => {
        let delement = (
          <DatePicker
            key={date.doc}
            defaultValue={moment(date.businessDate, dateFormat)}
            onChange={(dateObj, dateString) => {
              this.handleChange(dateObj, dateString);
            }}
            style={{ width: "100%" }}
            placeholder="MM-DD-YYYY"
            format={dateFormat}
            // disabled={!this.props.isEditable}
            showToday={false}
            disabled
          />
        );
        bdatepickers.push(delement);
      });
      if (bdatepickers.length > 0 && bdatepickers.length < 4) {
        return (
          <div style={{ overflowX: "scroll", overflowY: "auto" }}>
            {bdatepickers}
          </div>
        );
      } else if (bdatepickers.length >= 4) {
        return (
          <div
            style={{ overflowX: "scroll", overflowY: "auto", height: "150px" }}
          >
            {bdatepickers}
          </div>
        );
      } else {
        return <div></div>;
      }
    } else if (cellInfo.mydocs.value == "N/A") {
      return <div>N/A</div>;
    }
  }

  //format schedule types
  genScheduleTytpes(cellInfo) {
    //from mydocs
    let scheduleType = cellInfo[this.props.submissionScheduleIndex];

    //from connector
    let submissionSchedule = cellInfo.submissionSchedule;

    if (cellInfo.mydocs.value != "N/A" && scheduleType != undefined) {
      let formattedSchedules = [];

      scheduleType.map((schedule) => {
        let schedElement = <div>{schedule.value}</div>;
        formattedSchedules.push(schedElement);
      });
      if (formattedSchedules.length > 0 && formattedSchedules.length < 4) {
        return (
          <div style={{ overflowX: "scroll", overflowY: "auto" }}>
            {formattedSchedules}
          </div>
        );
      } else if (formattedSchedules.length >= 4) {
        return (
          <div
            style={{ overflowX: "scroll", overflowY: "auto", height: "150px" }}
          >
            {formattedSchedules}
          </div>
        );
      } else {
        return <div></div>;
      }
    } else {
      return submissionSchedule == undefined ? "" : submissionSchedule;
    }
  }

  /** Start of Ant Design Table Search */
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      // <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  /** Search Button click on Table column Search */
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  /** Reset Button click on Table column Search */
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  /** End of Ant Design Table Search */

  showTot(total, range) {
    return range[0] + " - " + range[1] + " of " + total + " items";
  }
  //render react table
  render() {
    const { sessionCard } = this.state;

    const tableData = this.props.tableData;
    tableData.forEach((element) => {
      element["key"] = sessionCard + "_" + element.chainId;
    });

    // const columns = precolumns.map((col, index) => ({
    const columns = this.state.columns.map((col, index) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: this.handleResize(index),
      }),
    }));

    // console.log('tableData', tableData, 'this.props.editedDropdown',
    // this.props.formattedSessionTime, 'this.props.mappedReports', this.props.mappedReports);
    // if(this.props.isGM){
    //   return (
    //     <Row type="flex" justify="center">
    //           <Col span={24}>
    //             <ReactDragListView.DragColumn {...this.dragProps}>
    //               <Table
    //                 className="table-striped-rows"
    //                 components={this.components}
    //                 columns={columns}
    //                 dataSource={tableData}
    //                 // scroll={{ y: 300, x: 3000 }}
    //                 scroll={{ x: 3000 }}
    //                 pagination={{ pageSizeOptions: ['3', '5', '10', '20', '50'], showSizeChanger: true, defaultPageSize: 3 }}
    //               />
    //             </ReactDragListView.DragColumn>
    //           </Col>
    //         </Row>
    //   );
    // }else{

    let paginate = {
      pageSizeOptions: ["3", "5", "10", "15"],
      showSizeChanger: true,
      defaultPageSize: 3,
      showTotal: this.showTot,
    };

    let scrollObj = { x: "100vw" };
    if (
      this.props.accessType === accessType.CORPORATE ||
      this.props.accessType === accessType.ONBOARDING_TEAM
    ) {
      paginate = false;
      scrollObj["y"] = this.state.innerHeight - 260;
    }
    //alert(window.innerHeight + " - " +JSON.stringify(scrollObj))
    return (
      <Collapse
        style={{ width: "100%" }}
        className="session-table-collapse"
        expandIcon={({ isActive }) => (
          <DoubleRightOutlined rotate={isActive ? -90 : 90} />
        )}
        expandIconPosition={"right"}
        bordered={false}
        defaultActiveKey={this.props.defaultActive}
      >
        <Panel
          className="session-table-panelheader"
          header={
            this.props.accessType === accessType.CORPORATE ||
            this.props.accessType === accessType.ONBOARDING_TEAM
              ? "Upload"
              : "Upload " +
                this.props.formattedSessionTime +
                " (" +
                this.props.shortTimeZone +
                ")"
          }
          key={sessionCard}
        >
          <Row type="flex" justify="center">
            <Col span={24}>
              <ReactDragListView.DragColumn {...this.dragProps}>
                <Table
                  className="table-striped-rows"
                  id="filetraceSessionTbl"
                  columns={columns}
                  scroll={scrollObj}
                  dataSource={tableData.sort((a, b) => {
                    return a.fileName.toLowerCase() < b.fileName.toLowerCase()
                      ? -1
                      : 1;
                  })}
                  pagination={paginate}
                  locale={{
                    emptyText: (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No File Found"
                      />
                    ),
                  }}
                  onChange={(pagination, filters, sorter, extra) => {
                    //special filter count not for end users
                    if (this.props.accessType !== accessType.END_USER) {
                      let filterCancel = true;
                      let filterkeys = Object.keys(filters);
                      for (const filter of filterkeys) {
                        if (filters[filter] != null) {
                          filterCancel = false;
                          break;
                        }
                      }

                      // console.log("Pagination", pagination)
                      // console.log("Filter :", filters);
                      // console.log("Extra :", extra);
                      if (!filterCancel) {
                        console.log(
                          "Filtering :",
                          extra.currentDataSource.length
                        );
                        this.setState({
                          filterUsed: extra.currentDataSource.length,
                        });
                      } else {
                        console.log("No Filter");
                        this.setState({ filterUsed: null });
                      }
                    }
                  }}
                />
              </ReactDragListView.DragColumn>
            </Col>
          </Row>
          {this.props.accessType === accessType.CORPORATE ||
          this.props.accessType === accessType.ONBOARDING_TEAM ? (
            <Row type="flex">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                {this.state.filterUsed == null ? (
                  <div className="pageBtnDiv">
                    <span className="ant-pagination-total-text">
                      {"Showing " +
                        this.props.gmTotal +
                        " of " +
                        this.props.allRecords +
                        " records"}
                    </span>
                    <button
                      className={
                        this.props.disableNext
                          ? "ant-pagination-disabled"
                          : "ant-pagination-item"
                      }
                      onClick={() => {
                        this.props.changePage("n");
                      }}
                      disabled={this.props.disableNext}
                    >
                      Next
                    </button>
                  </div>
                ) : (
                  <div class="pageBtnDiv">
                    <span className="ant-pagination-total-text">
                      {"Showing " + this.state.filterUsed + " records"}
                    </span>
                    <button className="ant-pagination-disabled" disabled={true}>
                      Next
                    </button>
                  </div>
                )}
              </Col>
            </Row>
          ) : (
            ""
          )}
        </Panel>
      </Collapse>
    );
    // }
  }
}

export default FileTraceTableSection;
